import React from 'react';
import { Card, Descriptions, Tag, Typography } from 'antd';

const { Title } = Typography;

const PersonalInfoTab: React.FC = () => {
    return (
        <div style={{padding: '16px 0'}}>
            <Title level={4}>Персональные данные участника</Title>
        </div>
    );
};

export default PersonalInfoTab;